module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_1@3x.09b0b3ec.png";